export const SPAN_FOR_HTTP = 'HTTP';
export const SPAN_KIND_CLIENT = 3;
export const SPAN_ATTR_HTTP_URL = 'url';
export const SPAN_ATTR_HTTP_METHOD = 'method';
export const SPAN_ATTR_HTTP_HEADERS = 'headers';
export const SPAN_ATTR_HTTP_PARAMS = 'params';
export const SPAN_ATTR_HTTP_DATA = 'data';
export const SPAN_ATTR_HTTP_BATCH = 'batch';
export const SPAN_ATTR_HTTP_CACHEABLE = 'cacheable';
